import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'INSTITUTION/PEOPLE';

export const {action: toggleChild} = createAction(`${domain}/TOGGLE_CHILD`, childId => ({childId}));

export const {action: selectChildren} = createAction(`${domain}/SELECT_CHILDREN`, childrenIds => ({childrenIds}));

export const {action: toggleEmployee} = createAction(`${domain}/TOGGLE_EMPLOYEE`, employeeId => ({employeeId}));

export const {action: selectEmployees} = createAction(`${domain}/SELECT_EMPLOYEES`, employeesIds => ({employeesIds}));

export const {
    action: checkin,
    success: checkinSuccess,
    failed: checkinFailed,
} = createAction(
    `${domain}/CHECKIN_PEOPLE`,
    (childrenIds, employeesIds, groupId) => ({childrenIds, employeesIds, groupId}),
    (childrenIds, employeesIds) => ({childrenIds, employeesIds}),
    (e, childrenIds, employeesIds) => ({e, childrenIds, employeesIds}),
);

export const {
    action: checkout,
    success: checkoutSuccess,
    failed: checkoutFailed,
} = createAction(
    `${domain}/CHECKOUT_PEOPLE`,
    (childrenIds, employeesIds) => ({childrenIds, employeesIds}),
    (childrenIds, employeesIds) => ({childrenIds, employeesIds}),
    (e, childrenIds, employeesIds) => ({e, childrenIds, employeesIds}),
);

export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAction(
    `${domain}/FETCH_ALL`,
    fetchProps => ({fetchProps}),
    (childrenIds, employeesIds) => ({childrenIds, employeesIds}),
    e => ({e}),
);

export const {action: resetFetching} = createAction(`${domain}/RESET_FETCHING`);

export const {action: refetch} = createAction(`${domain}/REFETCH`, groupIds => ({groupIds}));

export const {action: setStatusRegistrations} = createAction(
    `${domain}/SET_STATUS_REGISTRATIONS`,
    statusRegistrationStats => ({statusRegistrationStats}),
);

export const {action: createChild, success: createChildSuccess} = createAction(
    `${domain}/CREATE_CHILD`,
    () => ({}),
    child => ({child}),
);

export const {action: createEmployee, success: createEmployeeSuccess} = createAction(
    `${domain}/CREATE_EMPLOYEE`,
    () => ({}),
    employee => ({employee}),
);

export const {action: emptySelection} = createAction(`${domain}/EMPTY_SELECTION`, () => ({}));
